module.exports = __webpack_public_path__ + "img/male.20decfc7.png";